var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfigInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#9db425;stroke:rgba(0,0,0,0);stroke-miterlimit:10;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,16a15.927,15.927,0,0,1,.778-4.92c0-.008,0-.017,0-.026s.012-.017.015-.025A15.993,15.993,0,1,1,0,16ZM16,31.337A15.355,15.355,0,0,0,31.337,16,15.356,15.356,0,0,1,16,31.337ZM.662,16a15.31,15.31,0,0,0,.532,4.011A15.31,15.31,0,0,1,.662,16Zm15.235.315a.362.362,0,0,0,.1.017.287.287,0,0,0,.129-.032.3.3,0,0,1-.128.031.3.3,0,0,1-.1-.017L1.316,11.578Zm.412-.2s.005,0,.005-.008S16.309,16.106,16.309,16.111ZM1.522,10.947l14.146,4.6V.67A15.363,15.363,0,0,0,1.522,10.947ZM31.33,15.514A15.355,15.355,0,0,0,16.331.67,15.356,15.356,0,0,1,31.33,15.514Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M306.08,126.483a15.361,15.361,0,0,0-14.147,10.276l14.147,4.6Z",
    transform: "translate(-290.411 -125.811)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigInProgress);
export default __webpack_public_path__ + "static/media/config-in-progress.ff2d96788aa5ce966b3207d424a2b6ea.svg";
export { ForwardRef as ReactComponent };